// extracted by mini-css-extract-plugin
module.exports = {"ColumnValue":"ColumnValue___e9Prv"};